export const truncateString = (str: string, num: number): string => {
  if (str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
};

/**
 * Returns the uppercase first-letter initial with trailing dot.
 * If the first name is empty or whitespace, returns an empty string.
 */
export const formatFirstnameInitial = (firstname?: string): string => {
  const trimmed = firstname?.trim();
  if (!trimmed) {
    return '';
  }
  return `${trimmed.charAt(0).toUpperCase()}.`;
};
